export function isNodeEnv() {
    return (Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]");
}
export function getGlobalObject() {
    return (isNodeEnv()
        ? global
        : typeof window !== "undefined"
            ? window
            : typeof self !== "undefined"
                ? self
                : {});
}
//# sourceMappingURL=environment.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@appsignal/core/dist/esm/utils/environment.js
// module id = 1236
// module chunks = 0